/* components/Settings.svelte generated by Svelte v3.32.1 */
import {
	SvelteComponent,
	add_flush_callback,
	add_render_callback,
	append,
	attr,
	bind,
	binding_callbacks,
	check_outros,
	create_bidirectional_transition,
	create_component,
	destroy_component,
	detach,
	element,
	empty,
	group_outros,
	init,
	insert,
	mount_component,
	noop,
	safe_not_equal,
	space,
	transition_in,
	transition_out
} from "svelte/internal";

import { fly } from "svelte/transition";
import { createEventDispatcher } from "svelte";
import Checkbox from "./ui/Checkbox.svelte";
import NumberSpinner from "./ui/Number.svelte";
import Prop from "./ui/Prop.svelte";
import Select from "./ui/Select.svelte";
import Vector from "./ui/Vector.svelte";
import Button from "./Button.svelte";

function create_default_slot_1(ctx) {
	let button;
	let current;

	button = new Button({
			props: {
				svg: "file-download",
				text: "Download JSON",
				fullWidth: true
			}
		});

	button.$on("click", /*click_handler*/ ctx[15]);

	return {
		c() {
			create_component(button.$$.fragment);
		},
		m(target, anchor) {
			mount_component(button, target, anchor);
			current = true;
		},
		p: noop,
		i(local) {
			if (current) return;
			transition_in(button.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(button.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(button, detaching);
		}
	};
}

// (80:2) {#if sizing === "custom"}
function create_if_block_3(ctx) {
	let vector;
	let updating_x;
	let updating_y;
	let current;

	function vector_x_binding(value) {
		/*vector_x_binding*/ ctx[19].call(null, value);
	}

	function vector_y_binding(value) {
		/*vector_y_binding*/ ctx[20].call(null, value);
	}

	let vector_props = {
		type: "size",
		label: "Dimensions",
		min: 1,
		max: 4096 * 4,
		step: 1,
		draggable: false,
		units: "px"
	};

	if (/*width*/ ctx[4] !== void 0) {
		vector_props.x = /*width*/ ctx[4];
	}

	if (/*height*/ ctx[5] !== void 0) {
		vector_props.y = /*height*/ ctx[5];
	}

	vector = new Vector({ props: vector_props });
	binding_callbacks.push(() => bind(vector, "x", vector_x_binding));
	binding_callbacks.push(() => bind(vector, "y", vector_y_binding));

	return {
		c() {
			create_component(vector.$$.fragment);
		},
		m(target, anchor) {
			mount_component(vector, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const vector_changes = {};

			if (!updating_x && dirty & /*width*/ 16) {
				updating_x = true;
				vector_changes.x = /*width*/ ctx[4];
				add_flush_callback(() => updating_x = false);
			}

			if (!updating_y && dirty & /*height*/ 32) {
				updating_y = true;
				vector_changes.y = /*height*/ ctx[5];
				add_flush_callback(() => updating_y = false);
			}

			vector.$set(vector_changes);
		},
		i(local) {
			if (current) return;
			transition_in(vector.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(vector.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(vector, detaching);
		}
	};
}

// (94:2) {#if showFormatInfo}
function create_if_block_2(ctx) {
	let prop;
	let current;

	prop = new Prop({
			props: {
				$$slots: { default: [create_default_slot] },
				$$scope: { ctx }
			}
		});

	return {
		c() {
			create_component(prop.$$.fragment);
		},
		m(target, anchor) {
			mount_component(prop, target, anchor);
			current = true;
		},
		i(local) {
			if (current) return;
			transition_in(prop.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(prop.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(prop, detaching);
		}
	};
}

// (95:4) <Prop>
function create_default_slot(ctx) {
	let div;

	return {
		c() {
			div = element("div");
			div.innerHTML = `See <a target="_blank" href="https://github.com/mattdesl/looom-tools/blob/main/docs/formats.md" class="svelte-mlb2u1">here</a> for enabling other video formats.`;
			attr(div, "class", "format-info svelte-mlb2u1");
		},
		m(target, anchor) {
			insert(target, div, anchor);
		},
		d(detaching) {
			if (detaching) detach(div);
		}
	};
}

// (123:2) {#if format !== "mp4" && format !== "webm"}
function create_if_block(ctx) {
	let checkbox;
	let updating_value;
	let t;
	let if_block_anchor;
	let current;

	function checkbox_value_binding(value) {
		/*checkbox_value_binding*/ ctx[24].call(null, value);
	}

	let checkbox_props = { label: "Transparent Background" };

	if (/*transparentBackground*/ ctx[2] !== void 0) {
		checkbox_props.value = /*transparentBackground*/ ctx[2];
	}

	checkbox = new Checkbox({ props: checkbox_props });
	binding_callbacks.push(() => bind(checkbox, "value", checkbox_value_binding));
	let if_block = /*format*/ ctx[7] === "gif" && /*transparentBackground*/ ctx[2] && create_if_block_1(ctx);

	return {
		c() {
			create_component(checkbox.$$.fragment);
			t = space();
			if (if_block) if_block.c();
			if_block_anchor = empty();
		},
		m(target, anchor) {
			mount_component(checkbox, target, anchor);
			insert(target, t, anchor);
			if (if_block) if_block.m(target, anchor);
			insert(target, if_block_anchor, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const checkbox_changes = {};

			if (!updating_value && dirty & /*transparentBackground*/ 4) {
				updating_value = true;
				checkbox_changes.value = /*transparentBackground*/ ctx[2];
				add_flush_callback(() => updating_value = false);
			}

			checkbox.$set(checkbox_changes);

			if (/*format*/ ctx[7] === "gif" && /*transparentBackground*/ ctx[2]) {
				if (if_block) {
					if_block.p(ctx, dirty);

					if (dirty & /*format, transparentBackground*/ 132) {
						transition_in(if_block, 1);
					}
				} else {
					if_block = create_if_block_1(ctx);
					if_block.c();
					transition_in(if_block, 1);
					if_block.m(if_block_anchor.parentNode, if_block_anchor);
				}
			} else if (if_block) {
				group_outros();

				transition_out(if_block, 1, 1, () => {
					if_block = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(checkbox.$$.fragment, local);
			transition_in(if_block);
			current = true;
		},
		o(local) {
			transition_out(checkbox.$$.fragment, local);
			transition_out(if_block);
			current = false;
		},
		d(detaching) {
			destroy_component(checkbox, detaching);
			if (detaching) detach(t);
			if (if_block) if_block.d(detaching);
			if (detaching) detach(if_block_anchor);
		}
	};
}

// (128:4) {#if format === "gif" && transparentBackground}
function create_if_block_1(ctx) {
	let checkbox;
	let updating_value;
	let current;

	function checkbox_value_binding_1(value) {
		/*checkbox_value_binding_1*/ ctx[25].call(null, value);
	}

	let checkbox_props = { label: "Alpha Quantization" };

	if (/*quantizeWithAlpha*/ ctx[3] !== void 0) {
		checkbox_props.value = /*quantizeWithAlpha*/ ctx[3];
	}

	checkbox = new Checkbox({ props: checkbox_props });
	binding_callbacks.push(() => bind(checkbox, "value", checkbox_value_binding_1));

	return {
		c() {
			create_component(checkbox.$$.fragment);
		},
		m(target, anchor) {
			mount_component(checkbox, target, anchor);
			current = true;
		},
		p(ctx, dirty) {
			const checkbox_changes = {};

			if (!updating_value && dirty & /*quantizeWithAlpha*/ 8) {
				updating_value = true;
				checkbox_changes.value = /*quantizeWithAlpha*/ ctx[3];
				add_flush_callback(() => updating_value = false);
			}

			checkbox.$set(checkbox_changes);
		},
		i(local) {
			if (current) return;
			transition_in(checkbox.$$.fragment, local);
			current = true;
		},
		o(local) {
			transition_out(checkbox.$$.fragment, local);
			current = false;
		},
		d(detaching) {
			destroy_component(checkbox, detaching);
		}
	};
}

function create_fragment(ctx) {
	let div;
	let prop;
	let t0;
	let checkbox0;
	let updating_value;
	let t1;
	let checkbox1;
	let updating_value_1;
	let t2;
	let select0;
	let updating_value_2;
	let t3;
	let t4;
	let select1;
	let updating_value_3;
	let t5;
	let t6;
	let vector;
	let updating_x;
	let t7;
	let numberspinner;
	let updating_value_4;
	let t8;
	let div_transition;
	let current;

	prop = new Prop({
			props: {
				label: true,
				$$slots: { default: [create_default_slot_1] },
				$$scope: { ctx }
			}
		});

	function checkbox0_value_binding(value) {
		/*checkbox0_value_binding*/ ctx[16].call(null, value);
	}

	let checkbox0_props = { label: "Resample Paths" };

	if (/*resamplePaths*/ ctx[1] !== void 0) {
		checkbox0_props.value = /*resamplePaths*/ ctx[1];
	}

	checkbox0 = new Checkbox({ props: checkbox0_props });
	binding_callbacks.push(() => bind(checkbox0, "value", checkbox0_value_binding));

	function checkbox1_value_binding(value) {
		/*checkbox1_value_binding*/ ctx[17].call(null, value);
	}

	let checkbox1_props = { label: "Recenter" };

	if (/*recenter*/ ctx[0] !== void 0) {
		checkbox1_props.value = /*recenter*/ ctx[0];
	}

	checkbox1 = new Checkbox({ props: checkbox1_props });
	binding_callbacks.push(() => bind(checkbox1, "value", checkbox1_value_binding));

	function select0_value_binding(value) {
		/*select0_value_binding*/ ctx[18].call(null, value);
	}

	let select0_props = {
		label: "Size Mode",
		options: [
			{ value: "weave", name: "Same as Weave" },
			{ value: "window", name: "Fit to Window" },
			{ value: "custom", name: "Custom" }
		]
	};

	if (/*sizing*/ ctx[6] !== void 0) {
		select0_props.value = /*sizing*/ ctx[6];
	}

	select0 = new Select({ props: select0_props });
	binding_callbacks.push(() => bind(select0, "value", select0_value_binding));
	let if_block0 = /*sizing*/ ctx[6] === "custom" && create_if_block_3(ctx);

	function select1_value_binding(value) {
		/*select1_value_binding*/ ctx[21].call(null, value);
	}

	let select1_props = {
		label: "Format",
		options: /*formats*/ ctx[11]
	};

	if (/*format*/ ctx[7] !== void 0) {
		select1_props.value = /*format*/ ctx[7];
	}

	select1 = new Select({ props: select1_props });
	binding_callbacks.push(() => bind(select1, "value", select1_value_binding));
	let if_block1 = /*showFormatInfo*/ ctx[10] && create_if_block_2(ctx);

	function vector_x_binding_1(value) {
		/*vector_x_binding_1*/ ctx[22].call(null, value);
	}

	let vector_props = {
		type: "array",
		label: "Duration",
		min: 0.5,
		draggable: false,
		max: 50000,
		step: 0.1,
		units: "seconds"
	};

	if (/*duration*/ ctx[8] !== void 0) {
		vector_props.x = /*duration*/ ctx[8];
	}

	vector = new Vector({ props: vector_props });
	binding_callbacks.push(() => bind(vector, "x", vector_x_binding_1));

	function numberspinner_value_binding(value) {
		/*numberspinner_value_binding*/ ctx[23].call(null, value);
	}

	let numberspinner_props = {
		draggable: false,
		label: "FPS",
		min: 1,
		max: /*format*/ ctx[7] === "gif" ? 50 : 60,
		step: 1
	};

	if (/*fps*/ ctx[9] !== void 0) {
		numberspinner_props.value = /*fps*/ ctx[9];
	}

	numberspinner = new NumberSpinner({ props: numberspinner_props });
	binding_callbacks.push(() => bind(numberspinner, "value", numberspinner_value_binding));
	let if_block2 = /*format*/ ctx[7] !== "mp4" && /*format*/ ctx[7] !== "webm" && create_if_block(ctx);

	return {
		c() {
			div = element("div");
			create_component(prop.$$.fragment);
			t0 = space();
			create_component(checkbox0.$$.fragment);
			t1 = space();
			create_component(checkbox1.$$.fragment);
			t2 = space();
			create_component(select0.$$.fragment);
			t3 = space();
			if (if_block0) if_block0.c();
			t4 = space();
			create_component(select1.$$.fragment);
			t5 = space();
			if (if_block1) if_block1.c();
			t6 = space();
			create_component(vector.$$.fragment);
			t7 = space();
			create_component(numberspinner.$$.fragment);
			t8 = space();
			if (if_block2) if_block2.c();
			attr(div, "class", "settings svelte-mlb2u1");
		},
		m(target, anchor) {
			insert(target, div, anchor);
			mount_component(prop, div, null);
			append(div, t0);
			mount_component(checkbox0, div, null);
			append(div, t1);
			mount_component(checkbox1, div, null);
			append(div, t2);
			mount_component(select0, div, null);
			append(div, t3);
			if (if_block0) if_block0.m(div, null);
			append(div, t4);
			mount_component(select1, div, null);
			append(div, t5);
			if (if_block1) if_block1.m(div, null);
			append(div, t6);
			mount_component(vector, div, null);
			append(div, t7);
			mount_component(numberspinner, div, null);
			append(div, t8);
			if (if_block2) if_block2.m(div, null);
			current = true;
		},
		p(ctx, [dirty]) {
			const prop_changes = {};

			if (dirty & /*$$scope*/ 67108864) {
				prop_changes.$$scope = { dirty, ctx };
			}

			prop.$set(prop_changes);
			const checkbox0_changes = {};

			if (!updating_value && dirty & /*resamplePaths*/ 2) {
				updating_value = true;
				checkbox0_changes.value = /*resamplePaths*/ ctx[1];
				add_flush_callback(() => updating_value = false);
			}

			checkbox0.$set(checkbox0_changes);
			const checkbox1_changes = {};

			if (!updating_value_1 && dirty & /*recenter*/ 1) {
				updating_value_1 = true;
				checkbox1_changes.value = /*recenter*/ ctx[0];
				add_flush_callback(() => updating_value_1 = false);
			}

			checkbox1.$set(checkbox1_changes);
			const select0_changes = {};

			if (!updating_value_2 && dirty & /*sizing*/ 64) {
				updating_value_2 = true;
				select0_changes.value = /*sizing*/ ctx[6];
				add_flush_callback(() => updating_value_2 = false);
			}

			select0.$set(select0_changes);

			if (/*sizing*/ ctx[6] === "custom") {
				if (if_block0) {
					if_block0.p(ctx, dirty);

					if (dirty & /*sizing*/ 64) {
						transition_in(if_block0, 1);
					}
				} else {
					if_block0 = create_if_block_3(ctx);
					if_block0.c();
					transition_in(if_block0, 1);
					if_block0.m(div, t4);
				}
			} else if (if_block0) {
				group_outros();

				transition_out(if_block0, 1, 1, () => {
					if_block0 = null;
				});

				check_outros();
			}

			const select1_changes = {};
			if (dirty & /*formats*/ 2048) select1_changes.options = /*formats*/ ctx[11];

			if (!updating_value_3 && dirty & /*format*/ 128) {
				updating_value_3 = true;
				select1_changes.value = /*format*/ ctx[7];
				add_flush_callback(() => updating_value_3 = false);
			}

			select1.$set(select1_changes);

			if (/*showFormatInfo*/ ctx[10]) {
				if (if_block1) {
					if (dirty & /*showFormatInfo*/ 1024) {
						transition_in(if_block1, 1);
					}
				} else {
					if_block1 = create_if_block_2(ctx);
					if_block1.c();
					transition_in(if_block1, 1);
					if_block1.m(div, t6);
				}
			} else if (if_block1) {
				group_outros();

				transition_out(if_block1, 1, 1, () => {
					if_block1 = null;
				});

				check_outros();
			}

			const vector_changes = {};

			if (!updating_x && dirty & /*duration*/ 256) {
				updating_x = true;
				vector_changes.x = /*duration*/ ctx[8];
				add_flush_callback(() => updating_x = false);
			}

			vector.$set(vector_changes);
			const numberspinner_changes = {};
			if (dirty & /*format*/ 128) numberspinner_changes.max = /*format*/ ctx[7] === "gif" ? 50 : 60;

			if (!updating_value_4 && dirty & /*fps*/ 512) {
				updating_value_4 = true;
				numberspinner_changes.value = /*fps*/ ctx[9];
				add_flush_callback(() => updating_value_4 = false);
			}

			numberspinner.$set(numberspinner_changes);

			if (/*format*/ ctx[7] !== "mp4" && /*format*/ ctx[7] !== "webm") {
				if (if_block2) {
					if_block2.p(ctx, dirty);

					if (dirty & /*format*/ 128) {
						transition_in(if_block2, 1);
					}
				} else {
					if_block2 = create_if_block(ctx);
					if_block2.c();
					transition_in(if_block2, 1);
					if_block2.m(div, null);
				}
			} else if (if_block2) {
				group_outros();

				transition_out(if_block2, 1, 1, () => {
					if_block2 = null;
				});

				check_outros();
			}
		},
		i(local) {
			if (current) return;
			transition_in(prop.$$.fragment, local);
			transition_in(checkbox0.$$.fragment, local);
			transition_in(checkbox1.$$.fragment, local);
			transition_in(select0.$$.fragment, local);
			transition_in(if_block0);
			transition_in(select1.$$.fragment, local);
			transition_in(if_block1);
			transition_in(vector.$$.fragment, local);
			transition_in(numberspinner.$$.fragment, local);
			transition_in(if_block2);

			add_render_callback(() => {
				if (!div_transition) div_transition = create_bidirectional_transition(div, fly, { y: -10, duration: 250 }, true);
				div_transition.run(1);
			});

			current = true;
		},
		o(local) {
			transition_out(prop.$$.fragment, local);
			transition_out(checkbox0.$$.fragment, local);
			transition_out(checkbox1.$$.fragment, local);
			transition_out(select0.$$.fragment, local);
			transition_out(if_block0);
			transition_out(select1.$$.fragment, local);
			transition_out(if_block1);
			transition_out(vector.$$.fragment, local);
			transition_out(numberspinner.$$.fragment, local);
			transition_out(if_block2);
			if (!div_transition) div_transition = create_bidirectional_transition(div, fly, { y: -10, duration: 250 }, false);
			div_transition.run(0);
			current = false;
		},
		d(detaching) {
			if (detaching) detach(div);
			destroy_component(prop);
			destroy_component(checkbox0);
			destroy_component(checkbox1);
			destroy_component(select0);
			if (if_block0) if_block0.d();
			destroy_component(select1);
			if (if_block1) if_block1.d();
			destroy_component(vector);
			destroy_component(numberspinner);
			if (if_block2) if_block2.d();
			if (detaching && div_transition) div_transition.end();
		}
	};
}

function instance($$self, $$props, $$invalidate) {
	const dispatch = createEventDispatcher();
	let { recenter = false } = $$props;
	let { resamplePaths = false } = $$props;
	let { transparentBackground = false } = $$props;
	let { quantizeWithAlpha = false } = $$props;
	let { width = 1024 } = $$props;
	let { height = 768 } = $$props;
	let { sizing = "weave" } = $$props;
	let { showFormatInfo = true } = $$props;
	let { formats = ["mp4", "gif"] } = $$props;
	let { format = "mp4" } = $$props;
	let { duration = 5 } = $$props;
	let { fps = 30 } = $$props;
	let { qualityPreset = "high" } = $$props;
	let { time = 0 } = $$props;
	const click_handler = () => dispatch("download");

	function checkbox0_value_binding(value) {
		resamplePaths = value;
		$$invalidate(1, resamplePaths);
	}

	function checkbox1_value_binding(value) {
		recenter = value;
		$$invalidate(0, recenter);
	}

	function select0_value_binding(value) {
		sizing = value;
		$$invalidate(6, sizing);
	}

	function vector_x_binding(value) {
		width = value;
		$$invalidate(4, width);
	}

	function vector_y_binding(value) {
		height = value;
		$$invalidate(5, height);
	}

	function select1_value_binding(value) {
		format = value;
		$$invalidate(7, format);
	}

	function vector_x_binding_1(value) {
		duration = value;
		$$invalidate(8, duration);
	}

	function numberspinner_value_binding(value) {
		fps = value;
		$$invalidate(9, fps);
	}

	function checkbox_value_binding(value) {
		transparentBackground = value;
		$$invalidate(2, transparentBackground);
	}

	function checkbox_value_binding_1(value) {
		quantizeWithAlpha = value;
		$$invalidate(3, quantizeWithAlpha);
	}

	$$self.$$set = $$props => {
		if ("recenter" in $$props) $$invalidate(0, recenter = $$props.recenter);
		if ("resamplePaths" in $$props) $$invalidate(1, resamplePaths = $$props.resamplePaths);
		if ("transparentBackground" in $$props) $$invalidate(2, transparentBackground = $$props.transparentBackground);
		if ("quantizeWithAlpha" in $$props) $$invalidate(3, quantizeWithAlpha = $$props.quantizeWithAlpha);
		if ("width" in $$props) $$invalidate(4, width = $$props.width);
		if ("height" in $$props) $$invalidate(5, height = $$props.height);
		if ("sizing" in $$props) $$invalidate(6, sizing = $$props.sizing);
		if ("showFormatInfo" in $$props) $$invalidate(10, showFormatInfo = $$props.showFormatInfo);
		if ("formats" in $$props) $$invalidate(11, formats = $$props.formats);
		if ("format" in $$props) $$invalidate(7, format = $$props.format);
		if ("duration" in $$props) $$invalidate(8, duration = $$props.duration);
		if ("fps" in $$props) $$invalidate(9, fps = $$props.fps);
		if ("qualityPreset" in $$props) $$invalidate(13, qualityPreset = $$props.qualityPreset);
		if ("time" in $$props) $$invalidate(14, time = $$props.time);
	};

	return [
		recenter,
		resamplePaths,
		transparentBackground,
		quantizeWithAlpha,
		width,
		height,
		sizing,
		format,
		duration,
		fps,
		showFormatInfo,
		formats,
		dispatch,
		qualityPreset,
		time,
		click_handler,
		checkbox0_value_binding,
		checkbox1_value_binding,
		select0_value_binding,
		vector_x_binding,
		vector_y_binding,
		select1_value_binding,
		vector_x_binding_1,
		numberspinner_value_binding,
		checkbox_value_binding,
		checkbox_value_binding_1
	];
}

class Settings extends SvelteComponent {
	constructor(options) {
		super();

		init(this, options, instance, create_fragment, safe_not_equal, {
			recenter: 0,
			resamplePaths: 1,
			transparentBackground: 2,
			quantizeWithAlpha: 3,
			width: 4,
			height: 5,
			sizing: 6,
			showFormatInfo: 10,
			formats: 11,
			format: 7,
			duration: 8,
			fps: 9,
			qualityPreset: 13,
			time: 14
		});
	}
}

export default Settings;